<div class="report-main-controls">
  <div class="selectors-wrapper">
    @if (isAdmin) {
      <div class="controls">
        <app-cliente-select
          [options]="clientOptions"
          [selected]="selectedClientOption"
          (selectionChange)="onClientSelect($event)"
          placeholder="Seleccionar cliente">
        </app-cliente-select>
      </div>

      @if (selectedClientOption) {
        <div class="controls">
          <app-campana-select
            [options]="campaignOptions"
            [selected]="selectedCampaignOption"
            (selectionChange)="onCampaignSelect($event)"
            placeholder="Seleccionar campaña">
          </app-campana-select>
        </div>
      }
    } @else {
      <div class="controls">
        <app-campana-select
          [options]="campaignOptions"
          [selected]="selectedCampaignOption"
          (selectionChange)="onCampaignSelect($event)"
          placeholder="Seleccione una campaña">
        </app-campana-select>
      </div>
    }
  </div>

  <div class="page__actions">
    <button (click)="openFiltros()" [disabled]="!hasData" class="btn"
            type="button">{{ reportControlsComponent()?.filterButton }}
    </button>
    <button (click)="exportPdf.emit()" [disabled]="!hasData || isExporting" class="btn"
            type="button">{{ isExporting ? reportControlsComponent()?.exportButton : reportControlsComponent()?.generatingPDFMessage }}
    </button>
  </div>
</div>
